export const calendarTranslations: Record<
  string,
  {
    title: string;
    subtitle: string;
    view_list: string;
    view_month: string;
    view_week: string;
    view_day: string;
    loading: string;
    load_failed: string;
    retry: string;
    empty_title: string;
    empty_description: string;
    month_empty: string;
    type_revenue: string;
    type_expense: string;
    reminder_day_value: string;
    items_count_single: string;
    items_count_plural: string;
    no_category: string;
    no_commitments: string;
    previous_period: string;
    next_period: string;
  }
> = {
  pt: {
    title: "Calendário",
    subtitle: "Compromissos previstos a partir do orçamento",
    view_list: "Lista",
    view_month: "Mês",
    view_week: "Semana",
    view_day: "Dia",
    loading: "A carregar calendário...",
    load_failed: "Não foi possível carregar o calendário.",
    retry: "Tentar novamente",
    empty_title: "Sem compromissos agendados",
    empty_description: "Adicione lembretes às linhas do orçamento para os ver aqui.",
    month_empty: "Sem compromissos neste mês.",
    type_revenue: "Receita",
    type_expense: "Despesa",
    reminder_day_value: "Dia {{day}}",
    items_count_single: "{{count}} item",
    items_count_plural: "{{count}} itens",
    no_category: "Sem categoria",
    no_commitments: "Sem compromissos.",
    previous_period: "Período anterior",
    next_period: "Próximo período",
  },
  en: {
    title: "Calendar",
    subtitle: "Upcoming commitments based on your budget",
    view_list: "List",
    view_month: "Month",
    view_week: "Week",
    view_day: "Day",
    loading: "Loading calendar...",
    load_failed: "Failed to load calendar.",
    retry: "Retry",
    empty_title: "No commitments scheduled",
    empty_description: "Add reminders to budget lines to see them here.",
    month_empty: "No commitments this month.",
    type_revenue: "Revenue",
    type_expense: "Expense",
    reminder_day_value: "Day {{day}}",
    items_count_single: "{{count}} item",
    items_count_plural: "{{count}} items",
    no_category: "No category",
    no_commitments: "No commitments.",
    previous_period: "Previous period",
    next_period: "Next period",
  },
  es: {
    title: "Calendario",
    subtitle: "Compromisos previstos a partir del presupuesto",
    view_list: "Lista",
    view_month: "Mes",
    view_week: "Semana",
    view_day: "Día",
    loading: "Cargando calendario...",
    load_failed: "No se pudo cargar el calendario.",
    retry: "Reintentar",
    empty_title: "Sin compromisos programados",
    empty_description: "Añade recordatorios a las líneas del presupuesto para verlos aquí.",
    month_empty: "Sin compromisos este mes.",
    type_revenue: "Ingreso",
    type_expense: "Gasto",
    reminder_day_value: "Día {{day}}",
    items_count_single: "{{count}} elemento",
    items_count_plural: "{{count}} elementos",
    no_category: "Sin categoría",
    no_commitments: "Sin compromisos.",
    previous_period: "Periodo anterior",
    next_period: "Siguiente periodo",
  },
  et: {
    title: "Kalender",
    subtitle: "Eelarve põhjal planeeritud kohustused",
    view_list: "Loend",
    view_month: "Kuu",
    view_week: "Nädal",
    view_day: "Päev",
    loading: "Kalendri laadimine...",
    load_failed: "Kalendri laadimine ebaõnnestus.",
    retry: "Proovi uuesti",
    empty_title: "Kohustusi pole",
    empty_description: "Lisa eelarveridadele meeldetuletusi, et neid siin näha.",
    month_empty: "Sellel kuul kohustusi pole.",
    type_revenue: "Tulu",
    type_expense: "Kulu",
    reminder_day_value: "Päev {{day}}",
    items_count_single: "{{count}} kirje",
    items_count_plural: "{{count}} kirjet",
    no_category: "Kategooriata",
    no_commitments: "Kohustusi pole.",
    previous_period: "Eelmine periood",
    next_period: "Järgmine periood",
  },
  de: {
    title: "Kalender",
    subtitle: "Geplante Verpflichtungen basierend auf dem Budget",
    view_list: "Liste",
    view_month: "Monat",
    view_week: "Woche",
    view_day: "Tag",
    loading: "Kalender wird geladen...",
    load_failed: "Kalender konnte nicht geladen werden.",
    retry: "Erneut versuchen",
    empty_title: "Keine Verpflichtungen geplant",
    empty_description: "Füge Budgetzeilen Erinnerungen hinzu, um sie hier zu sehen.",
    month_empty: "Keine Verpflichtungen in diesem Monat.",
    type_revenue: "Einnahme",
    type_expense: "Ausgabe",
    reminder_day_value: "Tag {{day}}",
    items_count_single: "{{count}} Eintrag",
    items_count_plural: "{{count}} Einträge",
    no_category: "Keine Kategorie",
    no_commitments: "Keine Verpflichtungen.",
    previous_period: "Vorheriger Zeitraum",
    next_period: "Nächster Zeitraum",
  },
  fr: {
    title: "Calendrier",
    subtitle: "Engagements prévus à partir du budget",
    view_list: "Liste",
    view_month: "Mois",
    view_week: "Semaine",
    view_day: "Jour",
    loading: "Chargement du calendrier...",
    load_failed: "Impossible de charger le calendrier.",
    retry: "Réessayer",
    empty_title: "Aucun engagement prévu",
    empty_description: "Ajoutez des rappels aux lignes budgétaires pour les voir ici.",
    month_empty: "Aucun engagement ce mois-ci.",
    type_revenue: "Revenu",
    type_expense: "Dépense",
    reminder_day_value: "Jour {{day}}",
    items_count_single: "{{count}} élément",
    items_count_plural: "{{count}} éléments",
    no_category: "Sans catégorie",
    no_commitments: "Aucun engagement.",
    previous_period: "Période précédente",
    next_period: "Période suivante",
  },
  it: {
    title: "Calendario",
    subtitle: "Impegni previsti dal budget",
    view_list: "Lista",
    view_month: "Mese",
    view_week: "Settimana",
    view_day: "Giorno",
    loading: "Caricamento calendario...",
    load_failed: "Impossibile caricare il calendario.",
    retry: "Riprova",
    empty_title: "Nessun impegno pianificato",
    empty_description: "Aggiungi promemoria alle righe di budget per vederli qui.",
    month_empty: "Nessun impegno questo mese.",
    type_revenue: "Entrata",
    type_expense: "Spesa",
    reminder_day_value: "Giorno {{day}}",
    items_count_single: "{{count}} elemento",
    items_count_plural: "{{count}} elementi",
    no_category: "Senza categoria",
    no_commitments: "Nessun impegno.",
    previous_period: "Periodo precedente",
    next_period: "Periodo successivo",
  },
  nl: {
    title: "Kalender",
    subtitle: "Geplande verplichtingen op basis van het budget",
    view_list: "Lijst",
    view_month: "Maand",
    view_week: "Week",
    view_day: "Dag",
    loading: "Kalender laden...",
    load_failed: "Kalender laden mislukt.",
    retry: "Opnieuw proberen",
    empty_title: "Geen geplande verplichtingen",
    empty_description: "Voeg herinneringen toe aan budgetregels om ze hier te zien.",
    month_empty: "Geen verplichtingen deze maand.",
    type_revenue: "Inkomst",
    type_expense: "Uitgave",
    reminder_day_value: "Dag {{day}}",
    items_count_single: "{{count}} item",
    items_count_plural: "{{count}} items",
    no_category: "Geen categorie",
    no_commitments: "Geen verplichtingen.",
    previous_period: "Vorige periode",
    next_period: "Volgende periode",
  },
  sv: {
    title: "Kalender",
    subtitle: "Planerade åtaganden baserade på budgeten",
    view_list: "Lista",
    view_month: "Månad",
    view_week: "Vecka",
    view_day: "Dag",
    loading: "Laddar kalender...",
    load_failed: "Det gick inte att ladda kalendern.",
    retry: "Försök igen",
    empty_title: "Inga planerade åtaganden",
    empty_description: "Lägg till påminnelser på budgetrader för att se dem här.",
    month_empty: "Inga åtaganden denna månad.",
    type_revenue: "Intäkt",
    type_expense: "Kostnad",
    reminder_day_value: "Dag {{day}}",
    items_count_single: "{{count}} objekt",
    items_count_plural: "{{count}} objekt",
    no_category: "Ingen kategori",
    no_commitments: "Inga åtaganden.",
    previous_period: "Föregående period",
    next_period: "Nästa period",
  },
  da: {
    title: "Kalender",
    subtitle: "Planlagte forpligtelser baseret på budgettet",
    view_list: "Liste",
    view_month: "Måned",
    view_week: "Uge",
    view_day: "Dag",
    loading: "Indlæser kalender...",
    load_failed: "Kunne ikke indlæse kalenderen.",
    retry: "Prøv igen",
    empty_title: "Ingen planlagte forpligtelser",
    empty_description: "Tilføj påmindelser til budgetlinjer for at se dem her.",
    month_empty: "Ingen forpligtelser denne måned.",
    type_revenue: "Indtægt",
    type_expense: "Udgift",
    reminder_day_value: "Dag {{day}}",
    items_count_single: "{{count}} element",
    items_count_plural: "{{count}} elementer",
    no_category: "Ingen kategori",
    no_commitments: "Ingen forpligtelser.",
    previous_period: "Forrige periode",
    next_period: "Næste periode",
  },
  fi: {
    title: "Kalenteri",
    subtitle: "Budjettiin perustuvat tulevat sitoumukset",
    view_list: "Lista",
    view_month: "Kuukausi",
    view_week: "Viikko",
    view_day: "Päivä",
    loading: "Ladataan kalenteria...",
    load_failed: "Kalenterin lataus epäonnistui.",
    retry: "Yritä uudelleen",
    empty_title: "Ei suunniteltuja sitoumuksia",
    empty_description: "Lisää muistutuksia budjettiriveihin nähdäksesi ne täällä.",
    month_empty: "Ei sitoumuksia tässä kuussa.",
    type_revenue: "Tulo",
    type_expense: "Kulu",
    reminder_day_value: "Päivä {{day}}",
    items_count_single: "{{count}} kohde",
    items_count_plural: "{{count}} kohdetta",
    no_category: "Ei kategoriaa",
    no_commitments: "Ei sitoumuksia.",
    previous_period: "Edellinen jakso",
    next_period: "Seuraava jakso",
  },
};
